import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {useTranslation} from "react-i18next";


const UserIsActiveAutocomplete = ({ selected, setSelected, ...props }) => {
    const {t} = useTranslation("inputs");

    const isActiveLabels = {
        [true]: t(`userIsActiveAutocomplete.enabled`),
        [false]: t(`userIsActiveAutocomplete.disabled`),
    }
    const isActiveOptions = Object.keys(isActiveLabels)
    return <Autocomplete
        id="is-active-autocomplete"
        multiple
        value={selected}
        options={isActiveOptions}
        getOptionLabel={(s) => isActiveLabels[s]}
        filterOptions={(x) => x}
        onChange={(e, value) => setSelected(value)}
        renderInput={(params) => (
            <MDInput {...params}
                     variant="standard"
                     label={t('userIsActiveAutocomplete.label')}
                     placeholder={t('userIsActiveAutocomplete.placeholder')}
            />
        )}
        {...props}
    />
}

export default UserIsActiveAutocomplete;